import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Form,
  DatePicker,
  CascaderSelect,
  Message,
  Card,
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import moment from 'moment';
import 'antd/dist/antd.css';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';

const ElevatorServiceFrontDeskList = (props) => {
  const guestFace = client.service('guestFace');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  // const residentScanType = client.service('residentScanType');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);
  const [
    selectVisitorAppointmentArr,
    setSelectVisitorAppointmentArr,
  ] = useState([]);
  const [dataSelect, setDataSelect] = useState('');
  const [residentName, setResidentName] = useState('');
  const [reservationTimeStart, setReservationTimeStart] = useState('');
  const [reservationTimeEnd, setReservationTimeEnd] = useState('');
  const [visitorsName, setVisitorsName] = useState('');
  const [householdNumber, setHouseholdNumber] = useState(''); //戶號
  const [intervieweeName, setIntervieweeName] = useState('');
  const [intervieweeRemarks, setIntervieweeRemarks] = useState('');
  const [visitingReason, setVisitingReason] = useState('');
  const [peopleNumber, setPeopleNumber] = useState(1);
  const [takeCardStatus, setTakeCardStatus] = useState('未領卡'); //取卡狀態
  const [visitorsStatus, setVisitorsStatus] = useState('預約中'); //訪客狀態

  //AppointmentDialog

  const [
    selectHouseholdNumberDialog,
    setSelectHouseholdNumberDialog,
  ] = useState(false);
  const [addVisitorDialog, setAddVisitorDialog] = useState(false);
  const [cancleDialog, setCancleDialog] = useState(false);
  const [dataSourceSelect, setDataSourceSelect] = useState('');
  console.log(dataSourceSelect);

  const [visitorAppointmentCode, setVisitorAppointmentCode] = useState('');
  const [visitorAppointmentIndex, setVisitorAppointmentIndex] = useState('');

  //residentAccountNumbers
  async function funFindResident(para) {
    const result = await residentAccountNumbers.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  function serverResidentDataUpdate() {
    funFindResident({}).then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }
  useEffect(() => {
    serverResidentDataUpdate();
  }, []);

  //visitor
  async function funFindVisitor(para) {
    const result = await guestFace.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funCreateVisitor(obj) {
    await guestFace.create(obj);
  }
  async function funUpdateVisitor(id, obj) {
    await guestFace.update(id, obj);
  }
  async function funRemoveVisitor(id) {
    await guestFace.remove(id);
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  function serverVisitorDataUpdate() {
    funFindVisitor({}).then((result) => {
      setVisitorAppointmentArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverVisitorDataUpdate();
  }, []);

  //visitor Select householdNumber
  async function funFindVisitorSelect() {
    const result = await guestFace.find({
      query: {
        // visitorsStatus: '預約中',
        householdNumber: dataSelect,
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funCreateVisitorSelect(obj) {
    await guestFace.create(obj);
  }
  async function funUpdateVisitorSelect(id, obj) {
    await guestFace.update(id, obj);
  }
  async function funRemoveVisitorSelect(id) {
    await guestFace.remove(id);
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  function serverVisitorSelectDataUpdate() {
    funFindVisitorSelect().then((result) => {
      setSelectVisitorAppointmentArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverVisitorSelectDataUpdate();
  }, [dataSelect]);

  const dataSource = [];

  for (let i = 0; i < residentAccountNumbersArr.length; i++) {
    //第一層
    let building = residentAccountNumbersArr[i].building;
    let objBuilding = dataSource.find((item) => item.label === building);
    if (!objBuilding) {
      objBuilding = {
        value: `${building}`,
        label: `${building}`,
        children: [],
      };
      dataSource.push(objBuilding);
    }
    //第二層
    let floor = residentAccountNumbersArr[i].floor;
    let objFloor = objBuilding.children.find((item) => item.label === floor);
    if (!objFloor) {
      objFloor = {
        value: `${building}-${floor}`,
        label: `${floor}`,
        children: [],
      };
      objBuilding.children.push(objFloor);
    }

    //第三層
    let floorChild = residentAccountNumbersArr[i].floorChild;
    let objFloorChild = dataSource.find((item) => item.label === floorChild);
    if (!objFloorChild) {
      objFloorChild = {
        value: `${building}-${floor}-${floorChild}`,
        label: `${floorChild}`,
      };
      objFloor.children.push(objFloorChild);
    }
    // console.log(`==${i}th dataSource:`,dataSource)
  }

  function makeid(length) {
    let result = '';
    let characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  return (
    <>
      <Button
        className={styles.buttonAppointment}
        onClick={() => {
          setSelectHouseholdNumberDialog(true);
        }}
      >
        我要預約
      </Button>
      <h1>查詢記錄 請選擇下方戶號</h1>

      <Form.Item label="戶號">
        <CascaderSelect
          placeholder="請選擇戶號"
          dataSource={dataSource}
          onChange={(value, data, extra) => {
            residentAccountNumbers
              .find({ query: { householdNumber: value } })
              .then((res) => {
                console.log(
                  '==residentAccountNumbers find householdNumber success:',
                  res.data[0].userName
                );
                setDataSelect(value);
                setResidentName(res.data[0].userName);
              })
              .catch((error) => {
                console.log(
                  '==residentAccountNumbers find householdNumber:',
                  error
                );
              });
          }}
        ></CascaderSelect>
      </Form.Item>

      {selectVisitorAppointmentArr.map((item, index) => {
        return (
          <Card className={styles.cardContainer} key={index} free>
            <Card.Content>
              <div className={styles.publicAppointmentContent}>
                <div>
                  <h3>{`預約日期:${item.reservationTimeStart}`}</h3>
                  <h3>{`訪客姓名:${item.visitorsName}`}</h3>
                  <h3>{`拜訪原因:${item.visitingReason}`}</h3>
                  <h3>{`預約代號:${item.appointmentCode}`}</h3>
                </div>

                <Button
                  disabled={
                    selectVisitorAppointmentArr[index].visitorsStatus ===
                    '已取消'
                      ? true
                      : false
                  }
                  className={styles.cardCancleBtn}
                  type="secondary"
                  onClick={() => {
                    setCancleDialog(true);
                    setVisitorAppointmentCode(
                      selectVisitorAppointmentArr[index].appointmentCode
                    );
                    setVisitorAppointmentIndex(index);
                  }}
                >
                  取消預約
                </Button>
                <Dialog
                  visible={cancleDialog}
                  hasMask
                  className={styles.dialog}
                  footerActions={['ok']}
                  onOk={() => {
                    let item =
                      selectVisitorAppointmentArr[visitorAppointmentIndex];

                    item.visitorsStatus = '已取消';

                    funUpdateVisitor(item._id, item).then(() => {
                      Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '取消成功',
                        showConfirmButton: false,
                        timer: 1500,
                      });
                      serverVisitorDataUpdate();
                      setCancleDialog(false);
                    });
                  }}
                  onCancel={() => {
                    setCancleDialog(false);
                  }}
                  onClose={() => {
                    setCancleDialog(false);
                  }}
                >
                  <h1>
                    確定取消預約代號
                    <span className={styles.cancleText}>
                      {visitorAppointmentCode}
                    </span>
                    預約?{' '}
                  </h1>
                  <h1>確定後無法復原!!</h1>
                </Dialog>
              </div>
            </Card.Content>
          </Card>
        );
      })}

      <Dialog
        hasMask
        className={styles.dialog}
        visible={selectHouseholdNumberDialog}
        footer={false}
        onOk={() => {
          setSelectHouseholdNumberDialog(false);
        }}
        onCancel={() => {
          setSelectHouseholdNumberDialog(false);
        }}
        onClose={() => {
          setSelectHouseholdNumberDialog(false);
        }}
      >
        <div className={styles.householdNumberSelect}>
          <Form.Item label="戶號">
            <CascaderSelect
              placeholder="請選擇戶號"
              dataSource={dataSource}
              value={householdNumber}
              onChange={(value, data, extra) => {
                // console.log(value)
                residentAccountNumbers
                  .find({ query: { householdNumber: value } })
                  .then((res) => {
                    console.log(
                      '==residentAccountNumbers find householdNumber success:',
                      res.data[0]
                    );
                    setHouseholdNumber(res.data[0].householdNumber);
                    setResidentName(res.data[0].userName);
                  })
                  .catch((error) => {
                    console.log(
                      '==residentAccountNumbers find householdNumber:',
                      error
                    );
                  });
              }}
            ></CascaderSelect>
          </Form.Item>
        </div>
        <img
          className={styles.barcode}
          src="https://i.ibb.co/NmtS6tp/home.png"
          alt="receive"
          type="cover"
          width={'100%'}
          height={300}
        ></img>

        <div className={styles.householdNumberBox}>
          <h1>{householdNumber ? householdNumber : '請選擇戶號...'}</h1>
          <Button
            className={styles.householdNumberSend}
            type="secondary"
            onClick={() => {
              // serverDataUpdateHouseholds();
              setSelectHouseholdNumberDialog(false);
              setAddVisitorDialog(true);
              // setHouseholdNumber('')
            }}
          >
            確定
          </Button>
        </div>
      </Dialog>

      <Dialog
        hasMask
        className={styles.dialog}
        visible={addVisitorDialog}
        onOk={() => {
          setReservationTimeStart('');
          setReservationTimeEnd('');
          setVisitorsName('');
          setHouseholdNumber('');
          setIntervieweeName('');
          setIntervieweeRemarks('');
          setVisitingReason('');
          setPeopleNumber(1);
          setAddVisitorDialog(false),
            funCreateVisitor({
              createdTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              order: visitorAppointmentArr.length,
              reservationTimeStart: reservationTimeStart,
              reservationTimeEnd: reservationTimeEnd,
              visitorsName: visitorsName,
              householdNumber: householdNumber,
              residentName: residentName,
              intervieweeRemarks: intervieweeRemarks,
              visitingReason: visitingReason,
              peopleNumber: peopleNumber,
              takeCardStatus: takeCardStatus,
              appointmentCode: makeid(8),
              visitorsStatus: visitorsStatus,
              updatedTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            }).then(() => {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: '預約成功',
                showConfirmButton: false,
                timer: 1500,
              });
              serverVisitorDataUpdate();
            });
        }}
        onCancel={() => {
          setAddVisitorDialog(false);
        }}
        onClose={() => {
          setAddVisitorDialog(false);
        }}
      >
        <div>
          <h3>新增訪客預約及登記</h3>
          <Form.Item label="訪客姓名">
            <Input
              name="visitorsName"
              placeholder="請輸入姓名"
              onChange={(value) => {
                setVisitorsName(value);
              }}
            />
          </Form.Item>
          <Form.Item label="戶號">{householdNumber}</Form.Item>
          <Form.Item label="受訪人姓名">{residentName}</Form.Item>

          <Form.Item label="備註">
            <Input
              name="intervieweeRemarks"
              placeholder="請輸入受訪人資訊"
              onChange={(value) => {
                setIntervieweeRemarks(value);
              }}
            />
          </Form.Item>

          <Form.Item label="拜訪時間">
            <h5>預約時間</h5>
            <DatePicker
              showTime
              onChange={(value) => {
                setReservationTimeStart(
                  moment(value).format('YYYY-MM-DD HH:MM:SS')
                );
              }}
            />
            <h5>結束時間</h5>
            <DatePicker
              showTime
              onChange={(value) => {
                setReservationTimeEnd(
                  moment(value).format('YYYY-MM-DD HH:MM:SS')
                );
              }}
            />
          </Form.Item>
          <Form.Item label="人數(限輸入數字)">
            <Input
              value={peopleNumber}
              name="peopleNumber"
              placeholder="請輸入人數"
              onChange={(value) => {
                setPeopleNumber(value.replace(/[^\d]/g, ''));
              }}
            />
          </Form.Item>
          <Form.Item label="拜訪原因">
            <Input.TextArea
              name="content"
              placeholder="請輸入內容"
              maxLength={100}
              rows={4}
              hasLimitHint
              aria-label="input max length 100"
              onChange={(value) => {
                setVisitingReason(value);
              }}
            />
          </Form.Item>
        </div>
      </Dialog>
    </>
  );
};

export default ElevatorServiceFrontDeskList;
